import useAudioPlayer from "./useAudioPlayer";

export default useAudioPlayer;
